module.exports = __webpack_public_path__ + "img/card-compare-yuri.3b93de55.webp";